import { render, staticRenderFns } from "./invite-retailer.vue?vue&type=template&id=3c7532f7&scoped=true"
import script from "./invite-retailer.vue?vue&type=script&lang=js"
export * from "./invite-retailer.vue?vue&type=script&lang=js"
import style0 from "./invite-retailer.vue?vue&type=style&index=0&id=3c7532f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7532f7",
  null
  
)

export default component.exports